export const SET_PRODUCTS = 'SET_PRODUCTS';

export function setProducts({ options, productOptions, products }) {
  return {
    type: SET_PRODUCTS,
    payload: { options, productOptions, products },
  };
}
